import { withStyles } from '@material-ui/core';
import Label from '../../common/Label';
import Value from '../../common/Value';

const styles = (theme) => ({
  container: {
    margin: '14 0'
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
    flexWrap: 'wrap',
    marginTop: 4,
    fontWeight: 500,
  },
  packageCodeGroup: {
    display: 'flex',
    columnGap: '6px',
    '&:not(:last-child)': {
      borderRight: `1px solid ${theme.dividerColor}`,
      paddingRight: 10,
      marginRight: 10
    }
  },
  packageCodeValue: {
    fontWeight: 600,
    color: theme.dispatchPanelLabelValueColor,
  }
});

const PackageCodes = ({ classes, freightDescriptionDetails = [] }) => (
  <div className={classes.container}>
    <Label labelText="Package Type" />
    <div className={classes.valueContainer}>
      {freightDescriptionDetails.length > 0 ? (
        freightDescriptionDetails.map(({ packageCode, hu }, index) => {
          const shouldShowValue = hu !== null && hu !== undefined && hu !== '';
          return (
            <div key={index} className={classes.packageCodeGroup}>
              {packageCode && <Value value={packageCode} customClasses={classes.packageCodeValue}/>}
              {shouldShowValue && <Value value={`(HU-${hu})`}/>}
            </div>
          );
        })
      ) : (
        <Value value="NA"/>
      )}
    </div>
  </div>
);

export default withStyles(styles)(PackageCodes);
